//= require activestorage

import { Controller } from "@hotwired/stimulus"
import * as ActiveStorage from "@rails/activestorage"

export default class extends Controller {
  static targets = ["fileInput", "uploadButton", "loader"]

  connect() {
    ActiveStorage.start();
    console.log('File upload controller connected');
  }
}
